import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index.js';

// layout
import UserLayout from '@/views/layout/UserLayout.vue';
import KeeperLayout from '@/views/layout/KeeperLayout.vue';
import ManageLayout from '@/views/layout/ManageLayout.vue';
// 各view
// user
import UserLogin from '@/views/user/Login.vue';
import UserListInfo from '@/views/user/UserListInfo.vue';
import UserQrReader from '@/views/user/QrReader.vue';
import UserConfirmCheckIn from '@/views/user/ConfirmCheckIn.vue';
// keeper
import KeeperLogin from '@/views/keeper/Login.vue';
import KeeperMain from '@/views/keeper/Main.vue';
import KeeperRoomInfo from '@/views/keeper/RoomInfo.vue';
// manage
import Login from '@/views/manage/Login.vue';
import Unaccepted from '@/views/manage/Unaccepted.vue';
import Unregistered from '@/views/manage/Unregistered.vue';
import Accepted from '@/views/manage/Accepted.vue';
import Canceled from '@/views/manage/Canceled.vue';
import LodgingAdd from '@/views/manage/LodgingAdd.vue';
import ListInfo from '@/views/manage/ListInfo.vue';
import Owner from '@/views/manage/Owner.vue';
import MailList from '@/views/manage/MailList.vue';
import MailEdit from '@/views/manage/MailEdit.vue';
import ListingList from '@/views/manage/ListingList.vue';
import ListingEdit from '@/views/manage/ListingEdit.vue';
import PassReset from '@/views/manage/PassReset.vue';
import Clean from '@/views/manage/Clean.vue';
import CleanInfo from '@/views/manage/CleanInfo.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'user_login',
      component: UserLogin,
    },
    {
      path: '/user',
      component: UserLayout,
      children: [
        {
          path: 'user_list_info',
          name: 'user_list_info',
          component: UserListInfo,
        },
        {
          path: 'qrreader',
          name: 'user_qr_reader',
          component: UserQrReader,
        },
        {
          path: 'confirm_checkin',
          name: 'user_confirm_checkin',
          component: UserConfirmCheckIn,
        },
      ]
    },
    {
      path: '/housekeeper',
      name: 'keeper_login',
      component: KeeperLogin,
    },
    {
      path: '/housekeeper',
      component: KeeperLayout,
      children: [
        {
          path: 'keeper_main',
          name: 'keeper_main',
          component: KeeperMain,
        },
        {
          path: 'room_info/:date/:listing_id',
          name: 'room_info',
          component: KeeperRoomInfo,
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {status: 0},
    },
    {
      path: '/manage',
      component: ManageLayout,
      children: [
        {
          path: 'unregistered',
          name: 'unregistered',
          component: Unregistered,
          meta: {status: 1},
        },
        {
          path: 'unaccepted',
          name: 'unaccepted',
          component: Unaccepted,
          meta: {status: 2},
        },
        {
          path: 'accepted',
          name: 'accepted',
          component: Accepted,
          meta: {status: 3},
        },
        {
          path: 'canceled',
          name: 'canceled',
          component: Canceled,
          meta: {status: 4},
        },
        {
          path: 'lodging_add',
          name: 'lodging_add',
          component: LodgingAdd,
          meta: {status: 0},
        },
        {
          path: 'list_info',
          name: 'list_info',
          component: ListInfo,
          meta: {status: 0},
        },
        {
          path: 'owner',
          name: 'owner',
          component: Owner,
          meta: {status: 13},
        },
        {
          path: 'mail_list',
          name: 'mail_list',
          component: MailList,
          meta: {status: 12},
        },
        {
          path: 'mail_edit',
          name: 'mail_edit',
          component: MailEdit,
          meta: {status: 12},
        },
        {
          path: 'listing_list',
          name: 'listing_list',
          component: ListingList,
          meta: {status: 11},
        },
        {
          path: 'listing_edit',
          name: 'listing_edit',
          component: ListingEdit,
          meta: {status: 11},
        },
        {
          path: 'pass_reset',
          name: 'pass_reset',
          component: PassReset,
          meta: {status: 14},
        },
        {
          path: 'clean',
          name: 'clean',
          component: Clean,
          meta: {status: 21},
        },
        {
          path: 'clean_info',
          name: 'clean_info',
          component: CleanInfo,
          meta: {status: 0},
        },
      ]
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
});

router.afterEach((to) => {
  store.commit('loginInfo/set_status', to.meta.status);
});

// router.beforeEach((to, from, next) => {
//   if (to.path === '/' || to.path === '/register/request') {
//     next();
//     return;
//   }
//   if (store.getters['loginInfo/login_token'] === null || store.getters['loginInfo/login_token'] === '') {
//     next({path: '/', query: {type: 'reload'}});
//     return;
//   }
//   next();
// });

export default router;
